import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_2222_holiday_weekly_off: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Weekly Off Settings",
        style: {
            backgroundColor: "#F9FAFB",
        },
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                    borderRadius: 12,
                    padding: 16,
                },
                childComponents: [
                    {
                        componentType: ComponentType.SUMMARY_LIST,
                        DisplayName: "Weekly Off Settings",
                        Name: "holiday_weekly_off",
                        apiname: "holiday_weekly_off",
                        titleValue: "day_of_week",
                        TableName: "holiday_weekly_off",
                        Filter: "holiday_weekly_off.soft_delete=0",
                        Form: {
                            Name: "holiday_weekly_off",
                            TableName: "holiday_weekly_off",
                            HasLockedColumn: false,
                            Fields: [
                                {
                                    IncludeLabel: true,
                                    Label: "Day of Week",
                                    BindValue: "day_of_week",
                                    Json_Attribute: "day_of_week",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Paid Weekly Off",
                                    BindValue: "paid_weekly_off",
                                    Json_Attribute: "paid_weekly_off",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                    valueFormat: "boolean",
                                } as any,
                                {
                                    IncludeLabel: true,
                                    Label: "Status",
                                    BindValue: "status",
                                    Json_Attribute: "status",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Notes",
                                    BindValue: "notes",
                                    Json_Attribute: "notes",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                            ],
                        },
                        SummeryActions: [
                            {
                                ActionType: "Edit",
                                Label: "Edit",
                                Action: {
                                    Action: "edit_weekly_off",
                                },
                                ScreenId: "2225",
                                visibility: [1],
                            },
                            {
                                ActionType: "Delete",
                                Label: "Delete",
                                Action: {
                                    Action: "Delete",
                                    Module: "holiday_weekly_off",
                                },
                                visibility: [1],
                            },
                        ],
                    } as any,
                ],
            },
        ],
    },
];
